<template>
  <div
    v-loading="loading"
    class="establish"
  >
    <div class="establish_TitleArea">
      <h3 class="title">创建落地页</h3>
      <i
        class="icon"
        @click="$emit('close')"
      >X</i>
    </div>
    <div class="establish_main">
      <div class="content">
        <SeInput
          :stylek="{margin:'0px 10px'}"
          placeholder="请选择公共落地页"
          @change="landingPage = $event"
          @input="landingPageInput"
          @blur="$event()"
        />
        <SeInput
          :stylek="{margin:'0px 10px'}"
          placeholder="请选择小说"
          @change="template = $event"
          @input="templateInput"
          @blur="$event()"
        />
      </div>
    </div>

    <div class="establish_button">
      <el-button
        type="primary"
        @click="determine"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import { getLandingPageList, treasureNovels, createLandingPage1 } from '@/api/landingPage.js'
import SeInput from './seInput/index.vue'
export default {
  components: {
    SeInput
  },
  data() {
    return {
      loading: false,
      landingPage: null,
      template: null
    }
  },
  async created() {
    await treasureNovels({ account_id: this.$route.query.account_id })
  },
  methods: {
    async landingPageInput(obj) {
      const data = await getLandingPageList(obj.value ? { page_name: obj.value, page_size: 1000 } : { page_size: 1000 })
      const s = data.data.list.map((item) => {
        return {
          ...item,
          name: item.page_name
        }
      })
      obj.cb(s)
    },
    async templateInput(obj) {
      const data = await treasureNovels({ account_id: this.$route.query.account_id })
      obj.cb(data.data)
    },
    async determine() {
      if (!this.landingPage || !this.template) {
        this.$message({
          message: !this.landingPage && !this.template ? '请选择落地页和模版' : !this.landingPage ? '请选择落地页' : '请选择小说',
          type: 'warning'
        })
        return
      }

      this.loading = true
      createLandingPage1({
        account_id: this.$route.query.account_id,
        page_name: this.landingPage.page_name,
        page_title: this.landingPage.page_title,
        novel_id: this.template.id,
        novel_name: this.template.name,
        common_page_id: this.landingPage.id,
        json: JSON.stringify({
          ...JSON.parse(this.landingPage.json_info),
          advertiserId: this.$route.query.account_id,
          novel_id: this.template.id
        })
      }).then((data) => {
        this.$message({
          message: '提交成功',
          type: 'success'
        })
        this.loading = false
        this.$emit('close', 'success')
      }).catch(() => {
        this.$message('错了哦，这是一条错误消息')
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.establish {
  width: 780px;
  height: 500px;
  background-color: #fff;
  border-radius: 7px;
  position: relative;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  display: flex;
  flex-direction: column;

  .establish_TitleArea {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid rgb(160, 160, 160);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    .title {
      font-weight: bold;
    }
    .icon {
      font-style: normal;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
  }

  .establish_main {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    flex-grow: 1;

    .content {
      width: 80%;
      display: flex;
      .el-autocomplete {
        width: 100%;
      }
    }
  }

  .establish_button {
    padding: 10px;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
